<div>
    <div class="template-container" *ngIf="chatService.messagesSubject.value.length < 2 && questions.length > 0">
      <div class="template-question" *ngFor="let question of questions" (click)="selectTemplateQuestion(question)">
        <span class="question-text">{{ question.text }}</span>
      </div>
    </div>
  <mat-form-field class="rounded-textarea" appearance="outline">
    <textarea
      matInput
      [(ngModel)]="questionMessage"
      placeholder="Message"
      autofocus
      (keydown.enter)="sendMessage($event)"
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="3"
      class="message-textarea fyxt-scroll"
    ></textarea>
    <div matSuffix class="message-button-container">
      <button *ngIf="!this.chatService.isLoading" mat-icon-button aria-label="Send message"
              (click)="sendMessage()">
        <mat-icon>send</mat-icon>
      </button>
      <button *ngIf="this.chatService.isLoading" mat-icon-button (click)="stopSending()"><mat-icon>stop_circle</mat-icon></button>

    </div>
  </mat-form-field>

</div>
